import PropTypes from 'prop-types';

import { trackEvent, trackLegacyEvent } from 'helpers/analytics';
import css from 'styles/components/hf/zappos/footerSurvey.scss';
import { vocUrl } from 'cfg/marketplace.json';

const FooterSurvey = ({ isMobile }, { testId = () => null }) => {
  const source = isMobile ? 'mobile-footer' : 'footer';
  return (
    <div className={css.survey}>
      <h3>Your Voice Matters</h3>
      <p>We&apos;d love to learn more about your shopping experiences on Zappos.com and how we can improve!</p>
      <a
        className={css.btn}
        href={`${vocUrl}?source=${source}`}
        onClick={() => {
          trackEvent('TE_FOOTER_FEEDBACK', source);
          trackLegacyEvent('Footer', 'Feedback', 'How-do-you-like-our-website');
        }}
        data-test-id={testId('footerSurvey')}
        target="_blank"
        rel="noopener noreferrer">Take Survey</a>
    </div>
  );
};

FooterSurvey.contextTypes = {
  testId: PropTypes.func
};

export default FooterSurvey;
